/**
 * Centralized frontend environment access.
 *
 * Phase C foundation (May 6, 2026): single source of truth for any
 * env-derived constant the React bundle needs. New code should import
 * from `@/core/env` instead of reading `process.env.*` inline.
 *
 * RULES:
 * - Only `REACT_APP_*` vars are visible to the bundle (CRA constraint).
 * - `API_URL` is REQUIRED by the rest of the app — fall back to empty
 *   string is preserved (legacy behavior) so missing config surfaces as
 *   an obvious 404 against `/api/...` instead of a `TypeError`.
 * - Do NOT add credential-like values here.
 */

export const API_URL = process.env.REACT_APP_BACKEND_URL || '';

/**
 * Backend URL alias — matches the variable name some legacy modules use.
 * Keep both exports so call sites can pick whichever reads more clearly.
 */
export const BACKEND_URL = API_URL;
